import React from 'react'
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import { ListItem } from '@mui/material'
import UserAvatarWithNameAndID from '../common/UserAvatarWithNameAndID';

const LinkListRow = ({ userId, userPic, name, isLinked, userName, distance }) => {
    return (
        <ListItem className='px-0 py-3'>
            <UserAvatarWithNameAndID
                userImg={userPic ? process.env.REACT_APP_PROFILE_URL + userPic : ""}
                avatarSize={48}
                userFullName={name}
                userId={userName}
            />
            <div className='d-flex flex-column'>
                <div className='d-flex'>
                    {distance && <span className='ms-2 app_text_gray app_text_12 d-flex align-items-center'><FmdGoodIcon style={{ fontSize: 12, marginRight: 3 }} />{`${distance} away`}</span>}
                </div>
            </div>
        </ListItem >
    )
}

export default LinkListRow